import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { Chip, ProgressBar, Text } from 'library/ui';

export interface FeeFreeShiftAllowance {
    business_location_id: number;
    business_location_name: string;
    limit: number;
    used: number;
    scheduled: number;
    remaining: number;
    resets_on: string;
}

export const CLOSE_TO_LIMIT = 2;

export function isOutOfShifts(allowance: FeeFreeShiftAllowance) {
    return allowance.remaining === 0;
}

export function isCloseToLimit(allowance: FeeFreeShiftAllowance) {
    return allowance.used > 0 && allowance.remaining > 0 && allowance.remaining <= CLOSE_TO_LIMIT;
}

export function RemainingLabel({ allowance }: { allowance: FeeFreeShiftAllowance }) {
    if (isOutOfShifts(allowance)) {
        return (
            <Chip size="small" bgColor={Colors.warningBackground} textColor={Colors.warning}>
                0 left — fees apply
            </Chip>
        );
    }

    return (
        <Text size="sm">
            <Text size="sm" weight="bold">
                {allowance.remaining}
            </Text>{' '}
            of {allowance.limit} left
        </Text>
    );
}

export function AllowanceBar({ allowance, compact = false }: { allowance: FeeFreeShiftAllowance; compact?: boolean }) {
    return (
        <BarWrapper $compact={compact}>
            <ProgressBar
                value={allowance.used}
                bufferValue={allowance.used + allowance.scheduled}
                max={allowance.limit}
                color={isOutOfShifts(allowance) ? Colors.warning : Colors.primary}
                bufferColor={Colors.secondaryMuted}
            />
        </BarWrapper>
    );
}

export function UsageBreakdown({ allowance }: { allowance: FeeFreeShiftAllowance }) {
    return (
        <Text size="sm" tone="secondary">
            {allowance.used} used · {allowance.scheduled} scheduled
        </Text>
    );
}

const BarWrapper = styled('div', { shouldForwardProp: (prop) => prop !== '$compact' })<{ $compact: boolean }>(
    ({ $compact }) => ({
        display: 'flex',
        flex: $compact ? 'none' : 1,
        width: $compact ? 200 : 'auto',
        minWidth: 120,
        maxWidth: '100%',
    }),
);
